import LearningListContainer from "../../Componant/Learning/LearningList";

const LearningList = () => {
  return (
    <div className="page-body">
      <LearningListContainer />
    </div>
  );
};

export default LearningList;
